<template>
    <div id="page">
        <BurgerMenu></BurgerMenu>
        <header>
            <slot name="header">
                <NavBar id="navbar"></NavBar>
            </slot>
        </header>
        
        <nav class="sidebar">

            <slot name="sidebar">
                <SideBar id="sidebar"></SideBar>
            </slot>
        </nav>
        
        <main>
            <BreadCrumbs></BreadCrumbs>
            <slot></slot>
        </main>

        <footer>
            <slot name="footer" >
                <TheFooter />
            </slot>
        </footer>
        
    </div>
</template>

<script setup>
import NavBar from "@/components/common/NavBar";
import TheFooter from "@/components/common/TheFooter.vue";
import BreadCrumbs from "@/components/common/BreadCrumbs";
import SideBar from "@/components/common/SideBar";
import BurgerMenu from "@/components/common/BurgerMenu";
</script>

<style scoped lang="scss">
#page{

    --footer-margin-top: 5rem;
    --min-main-height: calc(100vh - (3.15rem * 2) - var(--navbar-height) - var(--footer-margin-top));
    display: grid;
    grid-template-areas: ".      header   header   ."
                         ".      nav      main     ."
                         "footer footer   footer   footer";
    grid-template-columns: var(--lateral-columns-width) var(--sidebar-width) 1fr var(--lateral-columns-width);
    grid-template-rows:  var(--navbar-height) minmax(max-content, var(--min-main-height)) 190px;
    column-gap: var(--column-gap-width);
    row-gap: 3.15rem;
    box-sizing: border-box;

    & > header{
    grid-area: header;
    }
    & > nav{
        grid-area: nav;
    }
    & > main {
        grid-area: main;
        box-sizing: border-box;
        min-height: 20.875rem; // This height forces to footer always display at the end of page without white bands.
    }
    & > footer{
        grid-area: footer;
        margin-top: var(--footer-margin-top);
    }

}


@include for-phone-only(){
    #page{
        grid-template-areas: "header"
                             "main";
        grid-template-columns: 100%;
        grid-template-rows: var(--navbar-height)  max-content;
        padding: 0 2rem 5rem 2rem; // 5rem at padding-bottom to avoid overlapping with burger menu.
        row-gap: 10px;
        column-gap: 0;

        & > .sidebar {
            display: none;
        }
        & > footer{
            display: none;
        }
    }
}
</style>
